"use client"

import React from "react"

import { setSessionAuthToken } from "@lib/hooks/use-auth-token"
import { useSession } from "@modules/signup-and-order-flow/signup-and-order-flow-v2/session-context"

import SignupFlow from "../../components/signup/SignupFlow"
import { StepProps } from "../step-registry"

const SignupNativeStep: React.FC<StepProps> = ({ onComplete, onBack, initialReferralData }: StepProps) => {
  const { sessionData, updateSession } = useSession()

  // When signup completes, we'll get an auth token and userUuid
  const handleSignupComplete = (authToken: string, userUuid: string) => {
    setSessionAuthToken(authToken)

    updateSession({
      user: { ...sessionData.user, userUuid },
      progress: { ...sessionData.progress, signupCompleted: true },
    })
    onComplete()
  }

  return (
    <SignupFlow
      treatments={sessionData.treatments}
      onSignupSuccess={handleSignupComplete}
      onClose={onBack}
      flowType="web_native"
      initialReferralData={initialReferralData}
    />
  )
}

export default SignupNativeStep
